import { Link } from "react-router-dom";
import { LegalPage } from "../components/LegalPage";

export default function Cgu() {
  return (
    <LegalPage
      title="Conditions générales d'utilisation | TN FOOD"
      description="Conditions générales d'utilisation du site tnfood.food — accès, contenu, propriété intellectuelle, responsabilité."
      path="/conditions-generales-utilisation"
      updated="janvier 2026"
    >
      <h2>1. Objet</h2>
      <p>
        Les présentes conditions générales d'utilisation (CGU) définissent les conditions d'accès et d'utilisation du
        site tnfood.food, édité par TN FOOD.
      </p>

      <h2>2. Acceptation</h2>
      <p>L'utilisation du site vaut acceptation pleine et entière des présentes CGU.</p>

      <h2>3. Accès au site</h2>
      <p>
        Le site est accessible 24h/24 et 7j/7, sauf en cas de maintenance, de panne ou d'événement indépendant de la
        volonté de TN FOOD.
      </p>

      <h2>4. Contenu informatif</h2>
      <p>
        Les prix affichés et les tarifs indicatifs présentés sur le site ont une valeur informative et ne sont pas
        contractuels. Seuls les devis signés et les conditions générales de vente prévalent.
      </p>

      <h2>5. Utilisation autorisée</h2>
      <p>
        Le site est destiné à un usage personnel et professionnel légitime. Sont interdits : toute tentative
        d'atteinte à la sécurité du site, toute extraction massive de contenus, tout usage frauduleux ou de nature à
        perturber le service.
      </p>

      <h2>6. Propriété intellectuelle</h2>
      <p>
        Les contenus du site (textes, images, logo, charte graphique) sont la propriété exclusive de TN FOOD ou de ses
        ayants droit. Toute reproduction sans autorisation écrite préalable est interdite.
      </p>

      <h2>7. Liens hypertextes</h2>
      <p>
        Le site peut contenir des liens vers des sites tiers. TN FOOD n'exerce aucun contrôle sur ces sites et décline
        toute responsabilité quant à leur contenu.
      </p>

      <h2>8. Données personnelles et cookies</h2>
      <p>
        Les traitements de données personnelles et l'usage des cookies sont décrits dans la{" "}
        <Link to="/politique-de-confidentialite">politique de confidentialité</Link>.
      </p>

      <h2>9. Responsabilité</h2>
      <p>
        TN FOOD s'efforce d'assurer l'exactitude des informations publiées, sans pouvoir en garantir l'exhaustivité.
        TN FOOD ne saurait être tenue responsable des dommages indirects liés à l'utilisation du site.
      </p>

      <h2>10. Modification des CGU</h2>
      <p>
        TN FOOD se réserve le droit de modifier les présentes CGU à tout moment. La version applicable est celle en
        ligne à la date de consultation.
      </p>

      <h2>11. Droit applicable et juridiction compétente</h2>
      <p>
        Les présentes CGU sont soumises au droit français. En cas de litige, compétence des tribunaux de Troyes, sous
        réserve des règles légales impératives.
      </p>
    </LegalPage>
  );
}
